import React from "react";
export default function LinkExpire() {
   const searchParams = new URLSearchParams(window.location.search);
   const queryValidation = searchParams.get("validation") || "";
   const isDob = queryValidation?.toLowerCase() === "dob";
   const link = isDob ? "https://provider.playbackhealth.com" : "https://pro.playbackhealth.com";
   const text = isDob ? "provider.playbackhealth.com" : "pro.playbackhealth.com";
   return (
      <div className="flex justify-center items-center w-screen h-[80vh] leading-[30px] text-center ">
         <div className="para-link-expire">
            <div className="header-link-expire">Link has expired!</div>
            <div>You can access the content always in our app.</div>
            If you are a patient or family member of the patient click here {"-> "}
            <a className="text-[#007bff]" href="https://patient.playbackhealth.com">
               patient.playbackhealth.com
            </a>
            <div>
               If you are a provider click here {"-> "}
               <a className="text-[#007bff]" href={link}>
                  {text}
               </a>{" "}
            </div>
         </div>
      </div>
   );
}
